import React from 'react';
import {
  Box, Container,
} from '@mui/material';
import { ZAvatar } from '@marageti/z4-lib';
import { ViewProps } from './types';
import ProfileCard from './profile-info';
import ProfileEditor from '../edit';
import styles from './styles';
import { EditAgentEmailForm } from '../../../components/modals/edit-agent-email-form';

const View = ({
  agent,
  contextMenuProps,
  editorOpen,
  emailEditorOpen,
  onCloseEditor,
  onEditAvatar,
}: ViewProps) => (
  <Container maxWidth="lg">
    <Box sx={{
      py: {
        desktop: 6.5,
        mobile: 3.5,
      },
    }}
    >
      <Box sx={styles.profileWrapper}>
        <Box sx={styles.avatarBoxMobile}>
          <ZAvatar
            size={128}
            loading={!agent}
            src={agent?.avatar}
          />
        </Box>
        <ProfileCard
          agent={agent}
          contextMenuProps={contextMenuProps}
          onEditAvatar={onEditAvatar}
        />
        <ProfileEditor open={editorOpen} onClose={onCloseEditor} />
        {agent && (
          <EditAgentEmailForm agent={agent} open={emailEditorOpen} onClose={onCloseEditor} />
        )}
      </Box>
    </Box>
  </Container>
);

export default View;
